
class signupForm {
  
    constructor(){
        let response = document.querySelector("[form-reponse]").innerHTML;
        if(document.querySelectorAll("#mc-embedded-subscribe").length > 0){
            document.querySelector("#mc-embedded-subscribe").addEventListener("click",(event)=>{
             
              setInterval(() => {
               if(document.querySelector("#mce-success-response").innerText == "Thank you for subscribing!"){
                document.querySelector("#mce-success-response").innerHTML = response;
               }
              }, 10);
            })
          }
    } 
}
new signupForm()